import { render, staticRenderFns } from "./GStudents.vue?vue&type=template&id=30b2bc89&scoped=true&"
import script from "./GStudents.vue?vue&type=script&lang=ts&"
export * from "./GStudents.vue?vue&type=script&lang=ts&"
import style0 from "./GStudents.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./GStudents.vue?vue&type=style&index=1&id=30b2bc89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b2bc89",
  null
  
)

export default component.exports